/** 页面信息 */
const page = new (function () {
  this.title = '交互平台'
  this.icon = 'iconfont iconicon_group'
  this.name = 'penalize_interactivePlatform'
  /**菜单编号 */
  this.code = 'penalize_interactivePlatform'
  /**菜单别名 */
  this.aliasName = 'penalize_interactivePlatform'
  /**路由地址 */
  this.path = '/penalize/interactivePlatform'
  //**接口权限 */
  this.permissions = []
})()

/** 路由信息 */
export const route = {
  page,
  component: () => import('./index.vue'),
  cache: false
}

export default page
